import { CircularProgress } from '@mui/material';
import React from 'react';

const MediumCircularProgress = ({ children, sx, ...otherProps }) => {
  return (
   <CircularProgress size={40} thickness={4} {...sx} {...otherProps}/>
  );
};

export default MediumCircularProgress;